import React, { useContext } from 'react';
import DiscoveryContext from '../../../../../contexts/discoveryContext/contextV2';
import Placepicker from '../../../../../components/Placepicker/Placepicker.react';
import { getSearchParamsFromLocation } from '../../../provider/location';
import { placepicker, placeContainer } from './styles.module.css';
import NearMe from './components/NearMe';

const LocationSelect = ({ update, forceConfirm }) => {
  const {
    filters: {
      location: { name: locationName },
    },
  } = useContext(DiscoveryContext);

  const placePickerOnChange = ({ target: { value: place } }) => {
    if (!place) {
      return;
    }

    const {
      name,
      geometry: { viewport },
    } = place;

    const ne = viewport.getNorthEast();
    const sw = viewport.getSouthWest();
    const params = getSearchParamsFromLocation({
      name,
      viewport: {
        ne: {
          lat: ne.lat(),
          lng: ne.lng(),
        },
        sw: {
          lat: sw.lat(),
          lng: sw.lng(),
        },
      },
    });
    update(params);
  };

  return (
    <>
      <div className={placeContainer}>
        <Placepicker
          className={placepicker}
          onChange={placePickerOnChange}
          value={{ name: locationName }}
        />
      </div>

      <NearMe forceConfirm={forceConfirm} />
    </>
  );
};

export default LocationSelect;
